<template>
    <!-- Nessuna UI propria: e' il ponte fra il File Storage e l'assegnazione
         foto→varianti. Il menu contestuale del DMS emette `assignVariantPhoto` con
         il documento; qui si risolve nella lista degli allegati del prodotto
         (l'unica con `variant_ids` idratato) e si apre il pannello con la foto
         gia' scelta. -->
    <div>
        <photo-variant-assign-panel
            v-model="assignOpen"
            :product-id="id"
            :photo="assignPhoto"
            @saved="onAssigned"
        ></photo-variant-assign-panel>
    </div>
</template>

<script>
    import PhotoVariantAssignPanel from '@/components/modules/products/PhotoVariantAssignPanel'
    import { isImageExt } from '@/components/utilities/imageFiles'

    export default {
        name: 'product-photo-assignment',

        components: {
            PhotoVariantAssignPanel
        },

        props: {
            id: Number
        },

        data() {
            return {
                photos: [],
                hasVariants: false,
                assignOpen: false,
                assignPhoto: null
            }
        },

        methods: {
            loadVariantsGate() {
                if (!this.id) return
                this.axios.get('products/' + this.id + '/variants/edit').then((response) => {
                    this.hasVariants = (response.data.model || []).some((v) => v.id > 0)
                    // Il File Storage e' generico e non sa se questo prodotto abbia
                    // varianti: senza questo annuncio mostrerebbe "Assegna a varianti"
                    // anche su un prodotto semplice, dove non c'e' nessuno a cui assegnare.
                    this.$eventBusUtility.$emit('variantPhotoAssignAvailable', this.hasVariants)
                })
            },

            loadPhotos() {
                if (!this.id) return Promise.resolve()
                return this.axios.post('attachmentslists/', { attachable_type: 'product', id: this.id }).then((response) => {
                    const all = Array.isArray(response.data.attachments) ? response.data.attachments : []
                    this.photos = all.filter((a) => isImageExt(a.ext))
                })
            },

            openAssign(photo) {
                this.assignPhoto = photo
                this.assignOpen = true
            },

            onAssigned(payload) {
                const photo = this.photos.find((p) => p.id === payload.photo_id)
                if (photo) this.$set(photo, 'variant_ids', payload.variant_ids)
            },

            /**
             * Input:  documento dal menu contestuale del File Storage (ha id, non i legami)
             * Fa:     risolve la foto nella lista locale — che arriva da attachmentslists
             *         ed e' l'unica con `variant_ids` idratato — e apre il pannello;
             *         se e' stata caricata dopo l'ultimo load, ricarica e riprova
             * Output: nessuno (apre il pannello o avvisa)
             */
            onExternalAssignRequest(doc) {
                if (!doc || doc.id == null) return

                if (!this.hasVariants) {
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: 'Questo prodotto non ha varianti salvate: nessuna variante a cui assegnare la foto',
                        value: true,
                        color: 'warning'
                    })
                    return
                }

                const known = this.photos.find((photo) => photo.id === doc.id)
                if (known) {
                    this.openAssign(known)
                    return
                }

                this.loadPhotos().then(() => {
                    const photo = this.photos.find((p) => p.id === doc.id)
                    if (photo) {
                        this.openAssign(photo)
                    } else {
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: 'Immagine non trovata fra gli allegati del prodotto',
                            value: true,
                            color: 'warning'
                        })
                    }
                })
            }
        },

        watch: {
            // La rotta `products-show` riusa l'istanza al cambio di :id (stesso
            // record di rotta, cambia solo il param): senza questo, navigando da
            // un prodotto all'altro senza smontare la Show resterebbero le varianti
            // del precedente — e "Assegna a varianti" aprirebbe il pannello sul
            // prodotto sbagliato. `photos` si ripara da solo al reload in
            // onExternalAssignRequest, il gate no.
            id() {
                this.photos = []
                this.hasVariants = false
                this.assignPhoto = null
                // Finche' non si sa nulla del nuovo prodotto la voce di menu resta
                // nascosta: l'annuncio precedente vale per un altro prodotto.
                this.$eventBusUtility.$emit('variantPhotoAssignAvailable', false)
                this.loadVariantsGate()
                this.loadPhotos()
            }
        },

        created() {
            this.loadVariantsGate()
            this.loadPhotos()
        },

        mounted() {
            this.$eventBusUtility.$on('assignVariantPhoto', this.onExternalAssignRequest)
        },

        beforeDestroy() {
            this.$eventBusUtility.$off('assignVariantPhoto', this.onExternalAssignRequest)
        }
    }
</script>
